import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import {
  TABS_DEFAULTS,
  TABS_VARIANT_CLASS_MAP,
  type TTabsListElement,
  type TTabsListProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { cn } from "@/ui/lib/utils";

export const TabsList = forwardRef<TTabsListElement, TTabsListProps>(
  (
    {
      className,
      variant = TABS_DEFAULTS.variant,
      ...props
    },
    ref,
  ) => (
    <TabsPrimitive.List
      data-component="TabsList"
      ref={ref}
      className={cn(
        "flex",
        TABS_VARIANT_CLASS_MAP[variant].list,
        className,
      )}
      {...props}
    />
  ),
);

TabsList.displayName = TabsPrimitive.List.displayName;
